import { AlertActions } from "@evertrue/et-components";

const alertTimeout = 4000;

export { AlertActions, alertTimeout };
